import { formNames } from './formNames';
export function createValidation(_ref) {
  let {
    names = formNames,
    locale,
    errors,
    createCustomValidators = [_ref2 => {
      let {
        validators
      } = _ref2;
      return validators;
    }]
  } = _ref;
  const validators = createDefaultValidators({
    formNames: names,
    locale,
    errorMessages: errors
  });
  const customValidatorFn = composeCustomValidators(createCustomValidators);
  const validate = createValidate({
    errorMessages: errors,
    locale,
    validators: customValidatorFn({
      validators,
      formNames: names,
      errorMessages: errors,
      locale
    })
  });
  return {
    validate
  };
}

function createValidate(_ref3) {
  let {
    errorMessages,
    locale,
    validators
  } = _ref3;
  return function validate(fields, formValues) {
    const fieldsWithErrors = fields.reduce(function reducer(result, field) {
      const validator = validators[field]; // eslint-disable-next-line eqeqeq

      if (typeof validator !== 'function' || validator == undefined) {
        return result;
      } //TODO: find out how to better infer here


      const value = formValues[field];
      const validationResult = validator({
        values: formValues,
        value,
        locale,
        errorMessages
      });

      if (validationResult === true) {
        return result;
      }

      result[field] = typeof validationResult === 'string' ? validationResult : errorMessages.missingValue;
      return result;
    }, {});
    return fieldsWithErrors;
  };
}

function createDefaultValidators(_) {
  return {
    manufacturer(_ref4) {
      let {
        value,
        errorMessages
      } = _ref4;
      return notEmpty(value) || errorMessages.manufacturer;
    },

    mainType(_ref5) {
      let {
        value,
        errorMessages
      } = _ref5;
      return notEmpty(value) || errorMessages.mainType;
    },

    builtDate(_ref6) {
      let {
        value,
        errorMessages
      } = _ref6;
      return notEmpty(value) || errorMessages.builtDate;
    },

    bodyType(_ref7) {
      let {
        value,
        errorMessages
      } = _ref7;
      return notEmpty(value) || errorMessages.bodyType;
    },

    mainTypeDetail(_ref8) {
      let {
        value,
        errorMessages
      } = _ref8;
      return notEmpty(value) || errorMessages.mainTypeDetail;
    },

    mainTypeSub(_ref9) {
      let {
        value,
        errorMessages
      } = _ref9;
      return notEmpty(value) || errorMessages.mainTypeSub;
    },

    mileage(_ref10) {
      let {
        value,
        errorMessages
      } = _ref10;
      const maxMileageValue = 999999999;
      return notEmpty(value) && Number(value) <= maxMileageValue || errorMessages.mileage;
    },

    licensePlate(_ref11) {
      let {
        value,
        errorMessages
      } = _ref11;
      return notEmpty(value) || errorMessages.licensePlate;
    },

    email(_ref12) {
      let {
        value,
        errorMessages
      } = _ref12;
      return isValidEmailPattern(value) ? true : errorMessages.email;
    }

  };
} //TODO: Move to a shared package


const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isValidEmailPattern() {
  let email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return emailRegex.test(email);
}
export function isEmpty(value) {
  // eslint-disable-next-line eqeqeq
  return value == undefined || value === '';
}

function notEmpty(value) {
  return !isEmpty(value);
}

function composeCustomValidators(fns) {
  const customValidator = function customValidator(_ref13) {
    let {
      validators,
      ...params
    } = _ref13;
    return fns.reduceRight((accumulator, fn) => {
      return fn({ ...params,
        validators: accumulator
      });
    }, validators);
  };

  return customValidator;
}